import React, { useState, useEffect, useRef } from "react"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"
import { Link } from "react-router-dom"

const AddProducer = props => {
  const formRef = useRef(null)
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [companies, setCompanies] = useState([])
  const [plants, setPlants] = useState([])
  const [allPlants, setAllPlants] = useState([])
  const [centers, setCenters] = useState([])
  const [allCenters, setAllCenters] = useState([])
  const [routes, setRoutes] = useState([])
  const [allRoutes, setAllRoutes] = useState([])
  const [collections, setCollections] = useState([])
  const [allCollections, setAllCollections] = useState([])
  const [states, setStates] = useState([])
  const [districts, setDistricts] = useState([])
  const [photo, setPhoto] = useState("")
  const [selectedCompany, setSelectedCompany] = useState("")
  const [selectedPlant, setSelectedPlant] = useState("")
  const [selectedCC, setSelectedCC] = useState("")
  const [selectedRoute, setSelectedRoute] = useState("")
  const [paymentMode, setPaymentMode] = useState("")
  const [isConsumer, setIsConsumer] = useState("0")

  const multipleCompanies = companies.length > 1

  const photoUpload = e => { setPhoto(e.target.files[0]) }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      const formData = new FormData()
      Object.keys(values).forEach(k => formData.append(k, values[k]))
      formData.append("producerPhoto", photo)
      const response = await api.post("create-producer", formData, { "Content-Type": "multipart/form-data" })
      if (response.data.success === true) { formRef.current.reset(); setSubmitted(true) }
    } catch (error) { /* Handled by global interceptor */ }
    setLoading(false)
  }

  const stateChangeHandler = async e => {
    try {
      const dists = await api.get("districts/" + e.target.value)
      setDistricts(Array.isArray(dists.data.data) ? dists.data.data : dists.data.data?.data || [])
    } catch (e) { setDistricts([]) }
  }

  useEffect(() => { getData() }, [])

  const getData = async () => {
    try {
      const [compResp, plantResp, cenResp, routeResp, collResp, stResp] = await Promise.all([
        api.get("companies"), api.get("plants"), api.get("centers"), api.get("routes"),
        api.get("collection-centers"), api.get("states")
      ])
      const comp = Array.isArray(compResp.data.data) ? compResp.data.data : compResp.data.data?.data || []
      const plt = Array.isArray(plantResp.data.data) ? plantResp.data.data : plantResp.data.data?.data || []
      const cen = Array.isArray(cenResp.data.data) ? cenResp.data.data : cenResp.data.data?.data || []
      const rte = Array.isArray(routeResp.data.data) ? routeResp.data.data : routeResp.data.data?.data || []
      const col = Array.isArray(collResp.data.data) ? collResp.data.data : collResp.data.data?.data || []
      const st = Array.isArray(stResp.data.data) ? stResp.data.data : stResp.data.data?.data || []
      setCompanies(comp)
      setAllPlants(plt); setPlants(plt)
      setAllCenters(cen); setCenters(cen)
      setAllRoutes(rte); setRoutes(rte)
      setAllCollections(col); setCollections(col)
      setStates(st)
    } catch (e) { console.error(e) }
  }

  // Cascading: Company → Plants
  const handleCompanyChange = e => {
    const v = e.target.value; setSelectedCompany(v); setSelectedPlant(""); setSelectedCC("")
    if (v) {
      const fp = allPlants.filter(p => String(p.company_id) === String(v))
      setPlants(fp)
      const plantIds = fp.map(p => String(p.id))
      setCenters(allCenters.filter(c => plantIds.includes(String(c.plant_id))))
      setRoutes(allRoutes); setCollections(allCollections)
    } else { setPlants(allPlants); setCenters(allCenters); setRoutes(allRoutes); setCollections(allCollections) }
  }
  // Cascading: Plant → CCs
  const handlePlantChange = e => {
    const v = e.target.value; setSelectedPlant(v); setSelectedCC(""); setSelectedRoute("")
    if (v) {
      setCenters(allCenters.filter(c => String(c.plant_id) === String(v)))
      setRoutes(allRoutes); setCollections(allCollections)
    } else {
      if (selectedCompany) {
        const fp = allPlants.filter(p => String(p.company_id) === String(selectedCompany))
        const plantIds = fp.map(p => String(p.id))
        setCenters(allCenters.filter(c => plantIds.includes(String(c.plant_id))))
      } else { setCenters(allCenters) }
      setRoutes(allRoutes); setCollections(allCollections)
    }
  }
  // Cascading: CC → Routes
  const handleCCChange = e => {
    const v = e.target.value; setSelectedCC(v); setSelectedRoute("")
    if (v) {
      setRoutes(allRoutes.filter(r => String(r.chillingCenter) === String(v)))
      setCollections(allCollections.filter(c => String(c.chillingCenter) === String(v)))
    } else { setRoutes(allRoutes); setCollections(allCollections) }
  }

  const sectionStyle = { border: "1px solid #e2e8f0", borderRadius: "8px", padding: "16px", marginBottom: "16px", background: "#f8fafc" }
  const sectionTitle = (icon, label) => (
    <h6 style={{ color: "#6366f1", marginBottom: "12px", fontSize: "14px" }}><i className={`fas ${icon} me-2`}></i>{label}</h6>
  )

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h4 style={{ margin: 0 }}>Add Producer</h4>
          <Link to="/producers" style={{ width: "32px", height: "32px", borderRadius: "4px", background: "#6c757d", color: "#fff",
            display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", textDecoration: "none" }}>
            <i className="fas fa-arrow-left"></i>
          </Link>
        </div>
        <div className="dashContent">
          <AvForm style={{ position: "relative" }} ref={formRef} className="form-horizontal mt-4"
            onValidSubmit={(e, v) => { handleValidSubmit(e, v) }}>

            {/* ── Location & Assignment ── */}
            <div style={sectionStyle}>
              {sectionTitle("fa-map-marker-alt", "Location & Assignment")}
              <Row>
                {multipleCompanies && (
                  <Col md={6}>
                    <div className="mb-3">
                      <label className="form-label">Company</label>
                      <select className="form-control" value={selectedCompany} onChange={handleCompanyChange}>
                        <option value="">Select Company</option>
                        {companies.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}
                      </select>
                    </div>
                  </Col>
                )}
                <Col md={6}>
                  <div className="mb-3">
                    <label className="form-label">Plant *</label>
                    <select className="form-control" value={selectedPlant} onChange={handlePlantChange}>
                      <option value="">Choose Plant</option>
                      {plants.map((p, i) => <option key={i} value={p.id}>{p.name}</option>)}
                    </select>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvField type="select" name="chillingCenter" label="Chilling Center *" required
                      value={selectedCC} onChange={handleCCChange}>
                      <option value="">Choose Chilling Center</option>
                      {centers.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}
                    </AvField>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvField type="select" name="route" label="Route *" required>
                      <option value="">Choose Route</option>
                      {routes.map((r, i) => <option key={i} value={r.id}>{r.routeName}</option>)}
                    </AvField>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvField type="select" name="collectionCenter" label="Collection Center *" required>
                      <option value="">Choose Collection Center</option>
                      {collections.map((c, i) => <option key={i} value={c.id}>{c.centerName}</option>)}
                    </AvField>
                  </div>
                </Col>
              </Row>
            </div>

            {/* ── Member Type ── */}
            <div style={sectionStyle}>
              {sectionTitle("fa-id-badge", "Member Type")}
              <Row>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="is_producer" label="Member is Producer *" required errorMessage="Pick one!" value="1">
                      <AvRadio label="Yes" value="1" /><AvRadio label="No" value="0" />
                    </AvRadioGroup>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="is_consumer" label="Member is Consumer *" required errorMessage="Pick one!" value="0"
                      onChange={(e, val) => setIsConsumer(val)}>
                      <AvRadio label="Yes" value="1" /><AvRadio label="No" value="0" />
                    </AvRadioGroup>
                  </div>
                </Col>
              </Row>
            </div>

            {/* ── Member Information ── */}
            <div style={sectionStyle}>
              {sectionTitle("fa-user", "Member Information")}
              <Row>
                <Col md={6}><div className="mb-3"><AvField name="producerNumber" label="Member Number *" type="text" required /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="producerName" label="Member Name *" type="text" required /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="producerMobile" label="Mobile *" type="text" required /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="producerRfid" label="Member RFID" type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="shortNo" label="Member Short Number" type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="door" label="Door Number" type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="village" label="Village Name" type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="taluk" label="Taluk Name" type="text" /></div></Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvField type="select" name="state" label="State" onChange={e => stateChangeHandler(e)}>
                      <option value="">Select State</option>
                      {states.map((s, i) => <option key={i} value={s.id}>{s.state}</option>)}
                    </AvField>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvField type="select" name="district" label="District">
                      <option value="">Select District</option>
                      {districts.map((d, i) => <option key={i} value={d.id}>{d.district}</option>)}
                    </AvField>
                  </div>
                </Col>
                <Col md={6}><div className="mb-3"><AvField name="pincode" label="Pincode" type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="producerAadhar" label="Aadhaar" type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="producerPAN" label="PAN" type="text" /></div></Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="is_registered_member" label="Producer is Registered Member *" required errorMessage="Pick one!" value="0">
                      <AvRadio label="Yes" value="1" /><AvRadio label="No" value="0" />
                    </AvRadioGroup>
                  </div>
                </Col>
                <Col md={6}><div className="mb-3"><AvField name="producerEmail" label="Email" type="email" /></div></Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="producerGender" label="Gender *" required errorMessage="Pick one!">
                      <AvRadio label="Male" value="male" /><AvRadio label="Female" value="female" /><AvRadio label="Other" value="other" />
                    </AvRadioGroup>
                  </div>
                </Col>
                <Col md={6}><div className="mb-3"><AvField name="totalCows" label="No Of Cows" type="number" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="totalBuffalos" label="No Of Buffalos" type="number" /></div></Col>
              </Row>
            </div>

            {/* ── Purchase & Payment ── */}
            <div style={sectionStyle}>
              {sectionTitle("fa-rupee-sign", "Purchase & Payment")}
              <Row>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="paymentMode" label="Purchase Payout Mode *" required errorMessage="Pick one!"
                      onChange={(e, val) => setPaymentMode(val)}>
                      <AvRadio label="Cash" value="0" /><AvRadio label="Bank Account" value="1" />
                    </AvRadioGroup>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <label className="form-label">Photo</label>
                    <input type="file" className="form-control" name="producerPhoto" onChange={e => photoUpload(e)} />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <label className="form-label">Applicable Milk Types for Purchase *</label>
                    <AvField type="select" name="applicableMilkTypes" required value="both">
                      <option value="both">Cow & Buffalo (Both)</option>
                      <option value="cow">Cow Only</option>
                      <option value="buffalo">Buffalo Only</option>
                    </AvField>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="milkType" label="Default Milk Type for Purchase" required errorMessage="Pick one!">
                      <AvRadio label="None" value="0" /><AvRadio label="Cow Milk" value="1" /><AvRadio label="Buffalo Milk" value="2" />
                    </AvRadioGroup>
                  </div>
                </Col>
                <Col md={6}><div className="mb-3"><AvField name="agricultureLand" label="Agriculture Land" type="text" /></div></Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvField type="select" name="community" label="Community">
                      <option value="">Select Community</option>
                      <option value="FC">FC</option><option value="BC">BC</option><option value="MBC">MBC</option>
                      <option value="SC">SC</option><option value="ST">ST</option><option value="OC">OC</option>
                    </AvField>
                  </div>
                </Col>
              </Row>
            </div>

            {/* ── Document Uploads ── */}
            <div style={sectionStyle}>
              {sectionTitle("fa-file-alt", "Document Uploads")}
              <span style={{ fontSize: "11px", color: "#94a3b8" }}>(Optional)</span>
              <Row className="mt-2">
                <Col md={4}><div className="mb-3"><label className="form-label">Upload Aadhaar Copy</label><input type="file" className="form-control" name="aadhaarCopy" /></div></Col>
                <Col md={4}><div className="mb-3"><label className="form-label">Upload PAN Copy</label><input type="file" className="form-control" name="panCopy" /></div></Col>
                <Col md={4}><div className="mb-3"><label className="form-label">Upload Bank Passbook/Statement</label><input type="file" className="form-control" name="bankPassbook" /></div></Col>
              </Row>
            </div>

            {/* ── Preferences ── */}
            <div style={sectionStyle}>
              {sectionTitle("fa-cogs", "Preferences")}
              <Row>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="printReceipt" label="Print Receipt after each Purchase" required errorMessage="Pick one!">
                      <AvRadio label="Yes" value="1" /><AvRadio label="No" value="0" />
                    </AvRadioGroup>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="sendSms" label="Send SMS after each purchase" required errorMessage="Pick one!">
                      <AvRadio label="Yes" value="1" /><AvRadio label="No" value="0" />
                    </AvRadioGroup>
                  </div>
                </Col>
                <Col md={12}><div className="mb-3"><AvField name="remarks" label="Remarks" type="textarea" rows="2" /></div></Col>
              </Row>
            </div>

            {/* ── Consumer / Sales Settings (conditional) ── */}
            <div style={{
              border: isConsumer === "1" ? "1px solid #0ea5e9" : "1px solid #e2e8f0",
              borderRadius: "8px", padding: isConsumer === "1" ? "16px" : "0 16px",
              marginBottom: "16px", background: isConsumer === "1" ? "#f0f9ff" : "transparent",
              maxHeight: isConsumer === "1" ? "800px" : "0",
              overflow: "hidden", opacity: isConsumer === "1" ? 1 : 0,
              transition: "all 0.4s ease-in-out"
            }}>
              <h6 style={{ color: "#0ea5e9", marginBottom: "12px", fontSize: "14px" }}>
                <i className="fas fa-shopping-cart me-2"></i>Consumer / Sales Settings
              </h6>
              <Row>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="consumerStatus" label="Consumer Status *" required={isConsumer === "1"} errorMessage="Pick one!" value="active">
                      <AvRadio label="Active" value="active" /><AvRadio label="Inactive" value="inactive" />
                    </AvRadioGroup>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="defaultSalesMilkType" label="Default Milk Type for Sales *" required={isConsumer === "1"} errorMessage="Pick one!">
                      <AvRadio label="None" value="0" /><AvRadio label="Cow" value="1" /><AvRadio label="Buffalo" value="2" />
                    </AvRadioGroup>
                  </div>
                </Col>
                <Col md={6}><div className="mb-3"><AvField name="defaultCowMilkPrice" label="Default Cow Milk Price for Sales" type="number" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="defaultBuffaloMilkPrice" label="Default Buffalo Milk Price for Sales" type="number" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="defaultCowAMQty" label="Default Cow Milk AM Quantity for Sales" type="number" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="defaultCowPMQty" label="Default Cow Milk PM Quantity for Sales" type="number" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="defaultBuffaloAMQty" label="Default Buffalo Milk AM Quantity for Sales" type="number" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="defaultBuffaloPMQty" label="Default Buffalo Milk PM Quantity for Sales" type="number" /></div></Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="salesPaymentMode" label="Sales Payment Mode *" required={isConsumer === "1"} errorMessage="Pick one!">
                      <AvRadio label="Pay As You Go" value="0" /><AvRadio label="Post Paid" value="1" /><AvRadio label="Pre Paid" value="2" />
                    </AvRadioGroup>
                  </div>
                </Col>
              </Row>
            </div>

            {/* ── Bank Details (conditional) ── */}
            <div style={{
              border: paymentMode === "1" ? "1px solid #6366f1" : "1px solid #e2e8f0",
              borderRadius: "8px", padding: paymentMode === "1" ? "16px" : "0 16px",
              marginBottom: "16px", background: paymentMode === "1" ? "#f8fafc" : "transparent",
              maxHeight: paymentMode === "1" ? "500px" : "0",
              overflow: "hidden", opacity: paymentMode === "1" ? 1 : 0,
              transition: "all 0.35s ease-in-out"
            }}>
              <h6 style={{ color: "#6366f1", marginBottom: "12px", fontSize: "14px" }}>
                <i className="fas fa-university me-2"></i>Bank Account Details <span style={{ fontSize: "11px", color: "#ef4444", fontWeight: "normal" }}>( Required for Bank Payment )</span>
              </h6>
              <Row>
                <Col md={4}><div className="mb-3"><AvField name="bank_ifsc" label="Bank IFSC *" type="text" placeholder="e.g. SBIN0001234" required={paymentMode === "1"} /></div></Col>
                <Col md={4}><div className="mb-3"><AvField name="bank_name" label="Bank Name *" type="text" required={paymentMode === "1"} /></div></Col>
                <Col md={4}><div className="mb-3"><AvField name="bank_branch" label="Branch Name *" type="text" required={paymentMode === "1"} /></div></Col>
              </Row>
              <Row>
                <Col md={4}><div className="mb-3"><AvField name="bank_account_number" label="Account Number *" type="text" required={paymentMode === "1"} /></div></Col>
                <Col md={4}><div className="mb-3"><AvField name="bank_confirm_account" label="Confirm Account Number *" type="text" required={paymentMode === "1"} /></div></Col>
                <Col md={4}><div className="mb-3"><AvField name="bank_account_name" label="Account Holder Name" type="text" /></div></Col>
              </Row>
            </div>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (<UncontrolledAlert color="success"><strong>Producer is Added!</strong></UncontrolledAlert>) : null}
              </div>
              <div className="col-6 text-end">
                <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                  {loading ? (<><Spinner animation="border" size="sm" /><span style={{ paddingLeft: "10px" }}>Adding...</span></>) : (<span>Add Producer</span>)}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default AddProducer
